import { Box, Divider, Paper, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { academic_year__get_list, loaded, loading } from 'components/mam-non-page/actions';
import { customSelectStyles } from 'config/constants/reactSelectConstant';
import { messageHelper } from 'helpers/messageHelper';
import { toastHelper } from 'helpers/toastHelper';
import usePrevious from 'helpers/usePrevious';
import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { callApiGetDuThuCongDoan } from 'redux/saga/cong-doan/thu-chi/du-thu-cong-doan/getDuThuCongDoan';
import { callApiSaveDuThuCongDoan } from 'redux/saga/cong-doan/thu-chi/du-thu-cong-doan/saveDuThuCongDoan';
import { callApiGetListOfCongDoanDanhMucThuCongDoan } from 'redux/saga/cong-doan/thu-chi/thu-cong-doan/getAllDanhMucThuCongDoan';
import DuThuCongDoanTable from './DuThuCongDoanTable';

function DuThuCongDoanPage() {
    const theme = useTheme();

    const { control, setValue, getValues, trigger, watch } = useForm();
    const dispatch = useDispatch();
    const [duthucongdoans, setDuthucongdoans] = useState(null);
    const [data, setData] = useState(null);
    const [danhMucDuThuCongDoan, setDanhMucDuThuCongDoan] = useState(null);

    const watches = watch();
    const values = getValues();
    const prevValues = usePrevious(values);

    const authenticationReducer = useSelector((state) => state.authenticationReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const congDoanId = get(authenticationReducer, 'userInfo.congDoanId');

    const academicYearsOptions = commonReducer.academicYears
        ? commonReducer.academicYears.map((item) => {
              return { value: item, label: item.name };
          })
        : [];

    const getDuThuCongDoan = useCallback((congDoanId, academicYear, nunId) => {
        setDuthucongdoans(null);
        setData(null);
        callApiGetDuThuCongDoan(congDoanId, academicYear)
            .then((res) => {
                setDuthucongdoans(res.data);
            })
            .catch((err) => {
                messageHelper.showError(err);
            });
    }, []);

    const onAcademicYearChange = (selectedOption) => {
        setValue('academicYear', selectedOption);
        trigger('academicYear');
    };

    useEffect(() => {
        dispatch(academic_year__get_list());
    }, [dispatch]);

    useEffect(() => {
        dispatch(loading());
        callApiGetListOfCongDoanDanhMucThuCongDoan()
            .then((res) => {
                setDanhMucDuThuCongDoan(res.data);
            })
            .catch((err) => {
                messageHelper.showError(err);
            })
            .finally(() => {
                dispatch(loaded());
            });
    }, [dispatch]);

    useEffect(() => {
        const isDiff = JSON.stringify(values) !== JSON.stringify(prevValues);
        const academicYear = get(values, 'academicYear.value.name');
        if (isDiff && academicYear && congDoanId) {
            getDuThuCongDoan(congDoanId, academicYear);
        }
    }, [values, watches, prevValues, dispatch, getDuThuCongDoan, congDoanId]);

    const onSubmit = () => {
        const academicYear = get(values, 'academicYear.value.name');
        const body = buildBody();
        if (academicYear) {
            dispatch(loading());
            callApiSaveDuThuCongDoan(congDoanId, body, academicYear)
                .then((res) => {
                    toastHelper.success('Lưu dự thu cộng đoàn thành công!');
                    getDuThuCongDoan(congDoanId, academicYear);
                })
                .catch((err) => {
                    messageHelper.showError(err);
                })
                .finally(() => {
                    dispatch(loaded());
                });
        }
    };

    const buildBody = () => {
        const resData = [...data];
        resData.forEach((item) => {
            item.junAmount = item.junAmount !== '' ? Number(item.junAmount) : undefined;
            item.julAmount = item.julAmount !== '' ? Number(item.julAmount) : undefined;
            item.augAmount = item.augAmount !== '' ? Number(item.augAmount) : undefined;
            item.sepAmount = item.sepAmount !== '' ? Number(item.sepAmount) : undefined;
            item.octAmount = item.octAmount !== '' ? Number(item.octAmount) : undefined;
            item.novAmount = item.novAmount !== '' ? Number(item.novAmount) : undefined;
            item.decAmount = item.decAmount !== '' ? Number(item.decAmount) : undefined;
            item.janAmount = item.janAmount !== '' ? Number(item.janAmount) : undefined;
            item.febAmount = item.febAmount !== '' ? Number(item.febAmount) : undefined;
            item.marAmount = item.marAmount !== '' ? Number(item.marAmount) : undefined;
            item.aprAmount = item.aprAmount !== '' ? Number(item.aprAmount) : undefined;
            item.mayAmount = item.mayAmount !== '' ? Number(item.mayAmount) : undefined;
            item.extraAmount1 = item.extraAmount1 !== '' ? Number(item.extraAmount1) : undefined;
            item.extraAmount2 = item.extraAmount2 !== '' ? Number(item.extraAmount2) : undefined;
        });
        return resData.map((item) => {
            return { ...item, ...{ danhMucThuCongDoanCode: item.code } };
        });
    };

    return (
        <>
            <Paper elevation={3}>
                <Box p={theme.spacing(0, 3)}>
                    <Typography variant="h6">Dự thu công đoàn</Typography>
                </Box>
                <Divider></Divider>
                <Box p={theme.spacing(1, 1)}>
                    <form>
                        <div className="row m-0">
                            <div className="col-md-4 pr-0">
                                <div className="row mr-0">
                                    <label className="mb-0 col-md-4 fmi-label pr-0" htmlFor="academicYear">
                                        Năm học:
                                    </label>
                                    <div className="col-md-8 p-0">
                                        <Controller
                                            id="academicYear"
                                            name="academicYear"
                                            control={control}
                                            defaultValue={null}
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: 'Vui lòng nhập năm học để lấy dự chi cá nhân!',
                                                },
                                            }}
                                            render={() => {
                                                return (
                                                    <Select
                                                        onChange={onAcademicYearChange}
                                                        options={academicYearsOptions}
                                                        classNamePrefix="fmi-react-select"
                                                        styles={customSelectStyles}
                                                    />
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                            <div className="col-md-3"></div>
                            <div className="col-md-3">
                                <div className="row mx-0 w-100">
                                    <button
                                        type="button"
                                        disabled={data === null}
                                        className={clsx({ 'export-button btn btn-primary mb-1 fmi-toolbar-button': true })}
                                        onClick={onSubmit}
                                    >
                                        Lưu
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Box>
            </Paper>
            {values.academicYear && (
                <DuThuCongDoanTable
                    academicYear={values.academicYear.value}
                    duthucongdoans={duthucongdoans}
                    danhmucthucongdoans={danhMucDuThuCongDoan}
                    data={data}
                    setData={setData}
                />
            )}
        </>
    );
}

export default DuThuCongDoanPage;
